module.exports = [{
      plugin: require('/Users/samuelparsons/development/smparsons.github.io/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":590},
    },{
      plugin: require('/Users/samuelparsons/development/smparsons.github.io/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-149832532-1"],"pluginConfig":{"head":true}},
    },{
      plugin: require('/Users/samuelparsons/development/smparsons.github.io/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/samuelparsons/development/smparsons.github.io/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/samuelparsons/development/smparsons.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
